module.exports = __webpack_public_path__ + "static/Galanogrotesque-Regular-dea7d8769f6d045a1a57d2242d5a9e19.woff";